import React from 'react';
import PropTypes from 'prop-types';
import { Chessboard, ChessboardItem } from 'Components/Chessboard';
import Button from 'Components/Button';

export default class ServiceCategoryList extends React.Component {
  static propTypes = {
    serviceCategories: PropTypes.array,
    deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  renderServiceCategory(serviceCategory) {
    const servicesCount = serviceCategory.services.length;
    const services = serviceCategory.services.slice(0, 4);

    return (
      <ChessboardItem
        entry={{ image: serviceCategory.image }}
        key={`service-category-${serviceCategory.id}`}
        flex
        consumptionText={serviceCategory.consumptionText}
        consumptionColorType="white"
      >
        <div>
          <h3 dangerouslySetInnerHTML={{ __html: serviceCategory.name }} />
          <p dangerouslySetInnerHTML={{ __html: serviceCategory.description }} />
          <ul>
            {services.map((service) => (
              <li key={`service-${service.id}`}>{service.name}</li>
            ))}
            {servicesCount > 4 && <li>und Weitere...</li>}
          </ul>
          <Button
            label="Details"
            type="secondary"
            href={`/service/werkstatt/uebersicht/${serviceCategory.slug}/`}
          />
        </div>
      </ChessboardItem>
    );
  }

  render() {
    const { serviceCategories, deeplinkId } = this.props;

    return (
      <Chessboard deeplinkId={deeplinkId}>
        {serviceCategories
          .filter((serviceCategory) => serviceCategory.services.length)
          .map((serviceCategory, i) => this.renderServiceCategory(serviceCategory, i))}
      </Chessboard>
    );
  }
}
